import axios from "axios";

import { API_URL } from "Constants";

type Table = "downloads" | "dns" | "home" | "service";

export default function addCount(table: Table, id?: string | number) {
  axios.get(`${API_URL}/add-count?table=${table}${id ? `&id=${id}` : ""}`);
}
